export const formatCurrency = (amount: number, currency = 'ARS'): string =>
  new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);

export const formatDate = (date: string | Date): string => {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('es-AR').format(d);
};

export const formatNumber = (value: number): string =>
  new Intl.NumberFormat('es-AR').format(value);
